import { OperationStatusType } from 'api/types/entity/operation';
import { useTranslation } from 'libs/i18n';
import { Chip, ChipProps, ChipVariant } from 'libs/ui';

export interface ChipOperationStatusProps
  extends Pick<ChipProps, 'size' | 'uppercase'> {
  status: OperationStatusType;
}

export const ChipOperationStatus = ({
  status,
  uppercase,
  size,
}: ChipOperationStatusProps) => {
  const { t } = useTranslation();

  let variant: ChipVariant | null = null;

  switch (status) {
    case OperationStatusType.Concluded:
      variant = 'green';
      break;
    case OperationStatusType.Cancelled:
      variant = 'red';
      break;
    default:
      variant = null;
      break;
  }

  if (variant === null) {
    return null;
  }

  return (
    <Chip
      size={size}
      text={t(`operation.operationStatuses.${status}`)}
      uppercase={uppercase}
      variant={variant}
    />
  );
};
